import { LOGIN, LOGOUT } from '../mutation-types'

const state = {
  authorized: localStorage.getItem('auth.token') != null,
  token: localStorage.getItem('auth.token')
    ? JSON.parse(localStorage.getItem('auth.token'))
    : null
}

const getters = {
  authorized (state) {
    return state.authorized
  },
  token (state) {
    return state.token
  },
  member (getters) {
    if (!getters.token) {
      return state.token.member || {}
    }
    return getters.token.member
  }
}

const mutations = {
  [LOGIN] (state, payload) {
    state.authorized = true
    state.token = payload.data ? payload.data : null
    localStorage.setItem('auth.token', JSON.stringify(state.token))
  },
  [LOGOUT] (state) {
    state.authorized = false
    state.token = null
    localStorage.removeItem('auth.token')
  }
}

export default {
  state,
  getters,
  mutations
}
